export default __webpack_public_path__ + "static/media/kelly.402f819a.png";